import { useMemo } from "react";
import moment from "moment";

import { Person } from "@/Common/Models/Person/Person";
import { DocumentActionHistoryType, IDocumentActionHistory } from "@/Documents/Models/Medical/IDocumentActionHistory";

interface IActionHistoryViewProps {
    history: IDocumentActionHistory[];
}

const getLogText = (log: IDocumentActionHistory): string => {
    const clinician = cacheStore.CliniciansWithInactive.find((c: Person) => c.ContactId === log.PerformedByContactId);
    const clinicianName = clinician ? `${clinician.prefix} ${clinician.LastName}, ${clinician.FirstName}` : "";
    return `${getActionLabel(log.ActionType)} ${clinicianName} ${cacheStore.GetString("OnDateLabel")} ${moment(log.PerformedAtDate).format("YYYY/MM/D")} ${cacheStore.GetString("AtLabel")} ${moment(log.PerformedAtDate).format("HH:mm:ss")}`;
};

const getActionLabel = (actionType: DocumentActionHistoryType): string => {
    const labels: Record<DocumentActionHistoryType, string> = {
        [DocumentActionHistoryType.Approved]: cacheStore.GetString("ApprovedByLabel"),
        [DocumentActionHistoryType.Revoked]: cacheStore.GetString("RevokedByLabel")
    };
    return labels[actionType] || "";
};

function DocumentActionHistoryView(props: Readonly<IActionHistoryViewProps>): JSX.Element {
    const renderedRows = useMemo(
        () => props.history
            .slice()
            .sort((a, b) =>
                moment(a.PerformedAtDate).diff(moment(b.PerformedAtDate)) // Sort by date ascending
            ),
        [props.history]
    );

    return (
        <ul>
            {renderedRows.map(log => <li key={log.Id}>{getLogText(log)}</li>)}
        </ul>
    );
}

export { DocumentActionHistoryView };
